import { ActionReducerMap } from '@ngrx/store';

import { oauthReducer, sharedRootReducer, toastReducer as sharedToastReducer } from '@digihaven/shared';

import { authenticationReducer } from '@reducers/authentication/authentication.reducer';
import { reducer as functionalityReducer } from '@reducers/functionality/functionality.reducer';

import { ApplicationState } from 'state';

import { filterReducer } from './filters/filter.reducer';
import { organisationReducer } from './organisation/organisation.reducer';
import { tokenReducer } from './token/token.reducer';
import { uploadReducer } from './upload/upload.reducer';
import { userReducer } from './user/user.reducer';

export const rootReducer: ActionReducerMap<ApplicationState> = {
    ...sharedRootReducer,
    authentication: authenticationReducer,
    token: tokenReducer,
    functionality: functionalityReducer,
    user: userReducer,
    organisation: organisationReducer,
    sharedToast: sharedToastReducer,
    upload: uploadReducer,
    filters: filterReducer,
    oauth: oauthReducer
};
